import { render, staticRenderFns } from "./BookingStepSelectPassenger.vue?vue&type=template&id=b2ec9630"
import script from "./BookingStepSelectPassenger.vue?vue&type=script&lang=ts"
export * from "./BookingStepSelectPassenger.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports